/**
 * Public commerce-policy facts shared by JSON-LD and feeds. Visible localized
 * copy is DB/i18n authored and is kept aligned by the policy regression tests.
 *
 * These values describe the statutory withdrawal policy for eligible distance
 * purchases. They are deliberately separate from warranty, trade-in quote,
 * store-pickup and repair time limits.
 */
export const COMMERCE_POLICY = Object.freeze({
  withdrawalDays: 14,
  withdrawalWindowStartsAt: 'physical_receipt_by_consumer_or_designated_third_party',
  statutoryExceptionsApply: true,
  applicableCountries: ['ES', 'PT'] as const,
  returnMethod: 'https://schema.org/ReturnByMail',
  ordinaryReturnFees: 'https://schema.org/ReturnFeesCustomerResponsibility',
  defectiveGoodsReturnFees: 'https://schema.org/FreeReturn',
  policyPath: '/p/return-and-warranty-policy',
})

export function effectiveSingleItemShippingFee(
  shippingFeeEUR: number | null | undefined,
  freeShippingThresholdEUR: number | null | undefined,
  itemPriceEUR: number | null | undefined,
): number {
  if (shippingFeeEUR == null || shippingFeeEUR <= 0) return 0
  if (
    freeShippingThresholdEUR != null
    && itemPriceEUR != null
    && itemPriceEUR >= freeShippingThresholdEUR
  ) return 0
  return shippingFeeEUR
}
